import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import {ReactJSXElement} from '@emotion/react/types/jsx-namespace'

interface Logo {
  url: string
  alt: string
}

interface LogoList {
  logo: Logo
  title: {
    text: string
  }
  aria_label: {
    text: string
  }
}
interface Props {
  logos: LogoList[]
  content: () => ReactJSXElement
}

const LogoGridSection = ({logos, content: Content}: Props) => {
  return (
    <Container component="section" maxWidth="lg" sx={{py: 10}}>
      <Content />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          alignItems: 'center',
          pt: 4,
        }}
      >
        {logos?.map(logo => {
          return (
            <Box
              key={logo.logo.alt}
              sx={{
                width: {xs: '50%', md: '25%'},
                px: {xs: 2, md: 4},
                mb: 6,
                textAlign: 'center',
              }}
            >
              <img
                title={logo.title.text}
                alt={logo.logo.alt}
                style={{maxWidth: '12rem', width: '100%'}}
                src={logo.logo.url}
                role="img"
                aria-label={logo.logo.alt}
              />
            </Box>
          )
        })}
      </Box>
    </Container>
  )
}

export default LogoGridSection
